module.exports = __webpack_public_path__ + "img/yuanyu.21fd6b42.jpg";